module Meevo.Components.Controls.SmartMover {
    export class ResourcesToCategoriesStrategy implements ICollectionPopulate {
        constructor(public parent: ICollectionBase<Model.ResourceCategory>, public child: ICollectionBase<Model.Resource>) {
        }

        populate(): void {
            for (const category of this.parent.models) {
                (<ISmartMoverCategoryModel<Model.ResourceCategory>>category).resetModels(
                    this.child.models.filter((resource) => resource.get('resourceCategoryId').toString() === category.get('id'))
                );
            }
        }
    }
}